import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { FundAnalytics } from 'src/app/models/fund-analytics-response.model'

@Injectable({
  providedIn: 'root',
})
export class FundAnalyticsService {
  public static readonly fundDailyAnalyticsEndpoint = '/fundDailyAnalytics'

  constructor(private readonly http: HttpClient) {}

  getFundAnalytics(fundId: string): Observable<FundAnalytics> {
    return this.http.get<FundAnalytics>(
      `vmf/api/${fundId}`.concat(
        FundAnalyticsService.fundDailyAnalyticsEndpoint,
      ),
    )
  }
}
